// @generated by protoc-gen-connect-es v1.6.1 with parameter "target=ts"
// @generated from file pm/project_manager.proto (package vsmr.pm.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { CreateProjectRequest, CreateProjectResponse, CreateWorkspaceRequest, CreateWorkspaceResponse, DeleteProjectRequest, DeleteProjectResponse, DeleteSimulationHistoryRequest, DeleteWorkspaceRequest, GetProjectRequest, GetProjectResponse, GetSimulationHistoryRequest, GetSimulationHistoryResponse, ListProjectsRequest, ListProjectsResponse, ListSimulationHistoriesByProjectRequest, ListSimulationHistoriesByUserRequest, ListSimulationHistoriesRequest, ListSimulationHistoriesResponse, ListWorkspacesRequest, ListWorkspacesResponse, SetProjectWorkspaceRequest, SetProjectWorkspaceResponse, UpdateProjectRequest, UpdateProjectResponse, UpdateWorkspaceRequest, UpdateWorkspaceResponse } from "./project_manager_pb.js";
import { Empty, MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service vsmr.pm.v1.ProjectManager
 */
export const ProjectManager = {
  typeName: "vsmr.pm.v1.ProjectManager",
  methods: {
    /**
     * ----------------------------------------------------------
     * projects CRUD
     * ----------------------------------------------------------
     * 프로젝트 생성. workspace_id 가 비면 호출자의 기본 워크스페이스(is_default 행)에 만든다 —
     * 기본 행이 없는 호출자(프로필 없이 온 호출자)는 FAILED_PRECONDITION. 소속 없는 프로젝트는 없다.
     *
     * @generated from rpc vsmr.pm.v1.ProjectManager.CreateProject
     */
    createProject: {
      name: "CreateProject",
      I: CreateProjectRequest,
      O: CreateProjectResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc vsmr.pm.v1.ProjectManager.GetProject
     */
    getProject: {
      name: "GetProject",
      I: GetProjectRequest,
      O: GetProjectResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc vsmr.pm.v1.ProjectManager.ListProjects
     */
    listProjects: {
      name: "ListProjects",
      I: ListProjectsRequest,
      O: ListProjectsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc vsmr.pm.v1.ProjectManager.UpdateProject
     */
    updateProject: {
      name: "UpdateProject",
      I: UpdateProjectRequest,
      O: UpdateProjectResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc vsmr.pm.v1.ProjectManager.DeleteProject
     */
    deleteProject: {
      name: "DeleteProject",
      I: DeleteProjectRequest,
      O: DeleteProjectResponse,
      kind: MethodKind.Unary,
    },
    /**
     * 프로젝트의 워크스페이스 소속 변경. workspace_id 가 비면 기본 워크스페이스로.
     * UpdateProject와 분리한 이유: UpdateProject는 mutable 필드 전체 치환이라 workspace_id를
     * 합류시키면 필드를 모르는 구버전 클라이언트의 저장이 소속을 지워버린다.
     *
     * @generated from rpc vsmr.pm.v1.ProjectManager.SetProjectWorkspace
     */
    setProjectWorkspace: {
      name: "SetProjectWorkspace",
      I: SetProjectWorkspaceRequest,
      O: SetProjectWorkspaceResponse,
      kind: MethodKind.Unary,
    },
    /**
     * ----------------------------------------------------------
     * workspaces CRUD — 프로젝트 상위 그룹 (사용자별)
     * ----------------------------------------------------------
     * 워크스페이스 생성. 이름은 사용자 내 유일 — 중복은 ALREADY_EXISTS.
     *
     * @generated from rpc vsmr.pm.v1.ProjectManager.CreateWorkspace
     */
    createWorkspace: {
      name: "CreateWorkspace",
      I: CreateWorkspaceRequest,
      O: CreateWorkspaceResponse,
      kind: MethodKind.Unary,
    },
    /**
     * 사용자의 워크스페이스 목록 (created_at 오름차순).
     *
     * @generated from rpc vsmr.pm.v1.ProjectManager.ListWorkspaces
     */
    listWorkspaces: {
      name: "ListWorkspaces",
      I: ListWorkspacesRequest,
      O: ListWorkspacesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * 이름/설명 변경. 타 사용자 소유면 NOT_FOUND.
     *
     * @generated from rpc vsmr.pm.v1.ProjectManager.UpdateWorkspace
     */
    updateWorkspace: {
      name: "UpdateWorkspace",
      I: UpdateWorkspaceRequest,
      O: UpdateWorkspaceResponse,
      kind: MethodKind.Unary,
    },
    /**
     * 삭제. 소속 프로젝트는 기본 워크스페이스로 옮긴 뒤 지운다(비파괴). 기본 워크스페이스(is_default)는
     * 지울 수 없다 — FAILED_PRECONDITION.
     *
     * @generated from rpc vsmr.pm.v1.ProjectManager.DeleteWorkspace
     */
    deleteWorkspace: {
      name: "DeleteWorkspace",
      I: DeleteWorkspaceRequest,
      O: Empty,
      kind: MethodKind.Unary,
    },
    /**
     * ----------------------------------------------------------
     * simulation_history — 행을 만들고 닫는 것은 Build 와 종결 저널뿐이다(실행 상태 권위).
     * 클라이언트는 읽고, 끝난 기록을 지울 수만 있다.
     * ----------------------------------------------------------
     *
     * @generated from rpc vsmr.pm.v1.ProjectManager.GetSimulationHistory
     */
    getSimulationHistory: {
      name: "GetSimulationHistory",
      I: GetSimulationHistoryRequest,
      O: GetSimulationHistoryResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc vsmr.pm.v1.ProjectManager.ListSimulationHistories
     */
    listSimulationHistories: {
      name: "ListSimulationHistories",
      I: ListSimulationHistoriesRequest,
      O: ListSimulationHistoriesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc vsmr.pm.v1.ProjectManager.DeleteSimulationHistory
     */
    deleteSimulationHistory: {
      name: "DeleteSimulationHistory",
      I: DeleteSimulationHistoryRequest,
      O: Empty,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc vsmr.pm.v1.ProjectManager.ListSimulationHistoriesByUser
     */
    listSimulationHistoriesByUser: {
      name: "ListSimulationHistoriesByUser",
      I: ListSimulationHistoriesByUserRequest,
      O: ListSimulationHistoriesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc vsmr.pm.v1.ProjectManager.ListSimulationHistoriesByProject
     */
    listSimulationHistoriesByProject: {
      name: "ListSimulationHistoriesByProject",
      I: ListSimulationHistoriesByProjectRequest,
      O: ListSimulationHistoriesResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

